module.exports = __webpack_public_path__ + "e79eacbde20b42b84ae6142b90aac259.svg";